/* ==========================================================================
   Mundo Dos Filtros — theme.js
   Comportamentos gerais: drawers, accordion, abas, sliders, hero e reveal.
   ========================================================================== */

(function () {
  'use strict';

  var overlay = null;
  var drawerAberto = null;

  /* ------------------------------------------------------------- Utils -- */

  function $(seletor, escopo) {
    return (escopo || document).querySelector(seletor);
  }

  function $$(seletor, escopo) {
    return Array.prototype.slice.call((escopo || document).querySelectorAll(seletor));
  }

  /* Marca um elemento como já inicializado. Evita que o editor de temas
     (shopify:section:load) crie cronômetros e listeners duplicados. */
  function jaIniciado(elemento, chave) {
    if (elemento.dataset[chave] === 'sim') return true;
    elemento.dataset[chave] = 'sim';
    return false;
  }

  function formatarDinheiro(centavos) {
    var valor = (centavos || 0) / 100;
    try {
      return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: (window.tema && window.tema.config.moeda) || 'BRL'
      });
    } catch (e) {
      return 'R$ ' + valor.toFixed(2).replace('.', ',');
    }
  }

  window.temaUtils = { $: $, $$: $$, formatarDinheiro: formatarDinheiro };

  /* ----------------------------------------------------------- Drawers -- */

  function abrirDrawer(drawer) {
    if (!drawer) return;
    fecharDrawer();
    drawer.classList.add('esta-aberto');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('esta-aberto');
    document.body.classList.add('sem-scroll');
    drawerAberto = drawer;

    var focavel = drawer.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focavel) window.setTimeout(function () { focavel.focus(); }, 120);
  }

  function fecharDrawer() {
    if (!drawerAberto) return;
    drawerAberto.classList.remove('esta-aberto');
    drawerAberto.setAttribute('aria-hidden', 'true');
    drawerAberto = null;
    if (overlay) overlay.classList.remove('esta-aberto');
    document.body.classList.remove('sem-scroll');
  }

  window.temaDrawer = { abrir: abrirDrawer, fechar: fecharDrawer };

  function iniciarDrawers() {
    overlay = $('[data-overlay]');

    document.addEventListener('click', function (evento) {
      var gatilho = evento.target.closest('[data-abrir-drawer]');
      if (gatilho) {
        evento.preventDefault();
        abrirDrawer(document.getElementById(gatilho.getAttribute('data-abrir-drawer')));
        return;
      }
      if (evento.target.closest('[data-fechar-drawer]')) {
        evento.preventDefault();
        fecharDrawer();
      }
    });

    if (overlay) overlay.addEventListener('click', fecharDrawer);

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') fecharDrawer();
    });
  }

  /* --------------------------------------------------------- Accordion -- */

  function iniciarAccordion() {
    document.addEventListener('click', function (evento) {
      var gatilho = evento.target.closest('[data-accordion-gatilho]');
      if (!gatilho) return;

      var painel = document.getElementById(gatilho.getAttribute('aria-controls'));
      var aberto = gatilho.getAttribute('aria-expanded') === 'true';

      gatilho.setAttribute('aria-expanded', String(!aberto));
      if (painel) painel.setAttribute('data-aberto', String(!aberto));
    });
  }

  /* -------------------------------------------------------------- Abas -- */

  function iniciarAbas() {
    $$('[data-abas]').forEach(function (grupo) {
      if (jaIniciado(grupo, 'abasIniciado')) return;

      var botoes = $$('[role="tab"]', grupo);

      botoes.forEach(function (botao) {
        botao.addEventListener('click', function () {
          botoes.forEach(function (outro) {
            outro.setAttribute('aria-selected', 'false');
            var painelOutro = document.getElementById(outro.getAttribute('aria-controls'));
            if (painelOutro) painelOutro.hidden = true;
          });
          botao.setAttribute('aria-selected', 'true');
          var painel = document.getElementById(botao.getAttribute('aria-controls'));
          if (painel) painel.hidden = false;
        });
      });
    });
  }

  /* ------------------------------------------------------------ Slider -- */

  function iniciarSliders() {
    $$('[data-slider-wrapper]').forEach(function (wrapper) {
      var pista = $('[data-slider]', wrapper);
      if (!pista) return;

      /* A marca fica na pista, não no wrapper: as recomendações chegam por
         AJAX depois da página, e o wrapper começa vazio. Marcar o wrapper
         aqui o daria como pronto antes de existir carrossel, e a segunda
         passada — a que enfim tem conteúdo — seria ignorada, deixando as
         setas mortas. Cada pista nova entra sem marca e é ligada. */
      if (jaIniciado(pista, 'sliderIniciado')) return;

      var anterior = $('[data-slider-anterior]', wrapper);
      var proximo = $('[data-slider-proximo]', wrapper);

      function passo() {
        var primeiro = pista.firstElementChild;
        return primeiro ? primeiro.offsetWidth + 16 : pista.clientWidth * 0.8;
      }

      function atualizarBotoes() {
        var fim = pista.scrollWidth - pista.clientWidth - 4;
        if (anterior) anterior.disabled = pista.scrollLeft <= 4;
        if (proximo) proximo.disabled = pista.scrollLeft >= fim;
      }

      if (anterior) {
        anterior.addEventListener('click', function () {
          pista.scrollBy({ left: -passo(), behavior: 'smooth' });
        });
      }
      if (proximo) {
        proximo.addEventListener('click', function () {
          pista.scrollBy({ left: passo(), behavior: 'smooth' });
        });
      }

      pista.addEventListener('scroll', atualizarBotoes, { passive: true });
      window.addEventListener('resize', atualizarBotoes);
      atualizarBotoes();

      /* A conta acima depende de scrollWidth e clientWidth, e o CSS adia o
         desenho das seções de baixo (content-visibility). Numa seção ainda não
         desenhada as duas medidas voltam zero, e as setas nasceriam desligadas
         para sempre — o listener de scroll não salva, porque sem seta viva não
         há como rolar. Refazemos a conta quando a seção chega perto da tela. */
      if ('IntersectionObserver' in window) {
        var observador = new IntersectionObserver(
          function (entradas) {
            entradas.forEach(function (entrada) {
              if (!entrada.isIntersecting) return;
              atualizarBotoes();
              observador.unobserve(entrada.target);
            });
          },
          { rootMargin: '200px 0px' }
        );
        observador.observe(pista);
      }
    });
  }

  /* --------------------------------------------------------------- Hero -- */

  function iniciarHero() {
    $$('[data-hero]').forEach(function (hero) {
      if (jaIniciado(hero, 'heroIniciado')) return;

      var pista = $('[data-hero-pista]', hero);
      var slides = $$('[data-hero-slide]', hero);
      var pontos = $$('[data-hero-ponto]', hero);
      var anterior = $('[data-hero-anterior]', hero);
      var proximo = $('[data-hero-proximo]', hero);
      var intervalo = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      if (!pista || slides.length < 2) return;

      /* A posição real da pista é a fonte da verdade, não um contador interno.
         Se uma rolagem for interrompida (o usuário arrasta, a aba perde o foco,
         a animação é cortada), o próximo passo recalcula a partir de onde o
         carrossel realmente está, em vez de seguir contando sozinho e
         dessincronizar dos pontinhos. */
      function indiceReal() {
        if (!pista.clientWidth) return 0;
        return Math.round(pista.scrollLeft / pista.clientWidth);
      }

      function marcarPontos(indice) {
        pontos.forEach(function (ponto, i) {
          ponto.classList.toggle('esta-ativo', i === indice);
          ponto.setAttribute('aria-current', i === indice ? 'true' : 'false');
        });
      }

      function irPara(indice) {
        var alvo = ((indice % slides.length) + slides.length) % slides.length;
        pista.scrollTo({ left: slides[alvo].offsetLeft, behavior: 'smooth' });
        marcarPontos(alvo);
      }

      function iniciarTimer() {
        if (!intervalo) return;
        pararTimer();
        timer = window.setInterval(function () { irPara(indiceReal() + 1); }, intervalo);
      }

      function pararTimer() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      pontos.forEach(function (ponto, i) {
        ponto.addEventListener('click', function () { irPara(i); iniciarTimer(); });
      });
      if (anterior) anterior.addEventListener('click', function () { irPara(indiceReal() - 1); iniciarTimer(); });
      if (proximo) proximo.addEventListener('click', function () { irPara(indiceReal() + 1); iniciarTimer(); });

      hero.addEventListener('mouseenter', pararTimer);
      hero.addEventListener('mouseleave', iniciarTimer);
      hero.addEventListener('focusin', pararTimer);

      var esperando;
      pista.addEventListener('scroll', function () {
        window.clearTimeout(esperando);
        esperando = window.setTimeout(function () {
          marcarPontos(indiceReal());
        }, 120);
      }, { passive: true });

      /* Se a janela mudar de tamanho, as posições dos slides mudam junto. */
      window.addEventListener('resize', function () {
        marcarPontos(indiceReal());
      });

      /* Aba em segundo plano não precisa de carrossel andando: além de gastar
         bateria à toa, cada troca de slide dispara o carregamento da imagem
         seguinte. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pararTimer();
        } else {
          iniciarTimer();
        }
      });

      marcarPontos(0);

      /* O autoplay só começa depois do load. Enquanto a página carrega, o
         banner é o maior elemento da primeira dobra — trocar de slide no meio
         disso obriga o navegador a buscar a imagem do slide 2 competindo com o
         resto e faz a área visível continuar mudando, que é exatamente o que o
         Speed Index penaliza. Parado, o banner fica pronto e a medição fecha. */
      if (document.readyState === 'complete') {
        iniciarTimer();
      } else {
        window.addEventListener('load', iniciarTimer, { once: true });
      }
    });
  }

  /* ---------------------------------------------------------- Anúncios -- */

  function iniciarAnuncios() {
    $$('[data-anuncio]').forEach(function (barra) {
      if (jaIniciado(barra, 'anuncioIniciado')) return;

      var itens = $$('[data-anuncio-item]', barra);
      var intervalo = parseInt(barra.getAttribute('data-intervalo'), 10) || 4000;
      var atual = 0;
      var relogio = null;
      if (itens.length < 2) return;

      function girar() {
        /* Zera todos antes de ativar o próximo: se algo mais mexer nas
           classes, a barra se autocorrige em vez de acumular itens. */
        itens.forEach(function (item) { item.classList.remove('esta-ativo'); });
        atual = (atual + 1) % itens.length;
        itens[atual].classList.add('esta-ativo');
      }

      function ligar() {
        if (relogio) return;
        relogio = window.setInterval(girar, intervalo);
      }

      function desligar() {
        if (relogio) window.clearInterval(relogio);
        relogio = null;
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { desligar(); } else { ligar(); }
      });

      /* A barra fica no topo, dentro da primeira dobra. Rodando durante o
         carregamento ela mantém a área visível em mudança e atrasa o ponto em
         que o navegador considera a tela pronta. Depois do load ninguém mais
         está medindo e o rodízio segue normal. */
      if (document.readyState === 'complete') {
        ligar();
      } else {
        window.addEventListener('load', ligar, { once: true });
      }
    });
  }

  /* -------------------------------------------------------- Quantidade -- */

  function limitesQuantidade(input) {
    var max = parseInt(input.getAttribute('max'), 10);
    return {
      min: parseInt(input.getAttribute('min'), 10) || 0,
      /* max ausente é "sem teto". Não dá para usar `|| Infinity` no parseInt
         porque max="0" é um teto legítimo e cairia no fallback. */
      max: isNaN(max) ? Infinity : max
    };
  }

  function iniciarQuantidade() {
    document.addEventListener('click', function (evento) {
      var botao = evento.target.closest('[data-quantidade-botao]');
      if (!botao) return;

      var wrapper = botao.closest('[data-quantidade]');
      var input = $('input', wrapper);
      if (!input) return;

      var limites = limitesQuantidade(input);
      var valor = parseInt(input.value, 10) || limites.min;
      var delta = botao.getAttribute('data-quantidade-botao') === 'mais' ? 1 : -1;

      valor = Math.min(limites.max, Math.max(limites.min, valor + delta));
      input.value = valor;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* O atributo max sozinho não impede digitar 999: o navegador só reclama se
       o formulário for validado, e o nosso envia por JS. Sem este corte, o
       pedido seguia acima do estoque e só quebrava lá no carrinho. */
    document.addEventListener('change', function (evento) {
      var input = evento.target;
      if (!input.matches || !input.matches('[data-quantidade] input')) return;

      var limites = limitesQuantidade(input);
      var valor = parseInt(input.value, 10);
      if (isNaN(valor)) valor = limites.min;

      var corrigido = Math.min(limites.max, Math.max(limites.min, valor));
      if (String(corrigido) !== input.value) input.value = corrigido;
    });
  }

  /* ------------------------------------------------------------ Header -- */

  function iniciarHeader() {
    var cabecalho = $('[data-cabecalho]');
    if (!cabecalho) return;
    if (jaIniciado(cabecalho, 'cabecalhoIniciado')) return;

    function aoRolar() {
      cabecalho.classList.toggle('esta-rolado', window.scrollY > 8);
    }

    window.addEventListener('scroll', aoRolar, { passive: true });
    aoRolar();

    var altura = cabecalho.offsetHeight;
    document.documentElement.style.setProperty('--header-altura', altura + 'px');

    /* Filtros da coleção, resumo do carrinho e afins só precisam desviar do
       cabeçalho quando ele fica preso ao rolar. Sem isso eles desciam a
       altura do cabeçalho à toa em lojas com o cabeçalho solto. */
    var fixo = cabecalho.classList.contains('cabecalho--fixo');
    document.documentElement.style.setProperty('--offset-fixo', (fixo ? altura : 0) + 'px');

    iniciarBuscaMobile(cabecalho);
  }

  /* ------------------------------------------------------ Busca mobile -- */

  /* A lupa do celular abre o campo de busca numa faixa abaixo do cabeçalho,
     em vez de mandar o cliente para a página de busca. É o mesmo campo do
     desktop, então a busca instantânea funciona igual nos dois. */
  function iniciarBuscaMobile(cabecalho) {
    var gatilho = $('[data-alternar-busca]', cabecalho);
    var painel = $('.cabecalho__busca', cabecalho);
    if (!gatilho || !painel) return;

    function abrir(sim) {
      cabecalho.classList.toggle('busca-aberta', sim);
      gatilho.setAttribute('aria-expanded', sim ? 'true' : 'false');

      if (sim) {
        var campo = $('input[type="search"]', painel);
        if (campo) window.setTimeout(function () { campo.focus(); }, 60);
      } else {
        var painelSugestoes = $('[data-busca-painel]', painel);
        if (painelSugestoes) painelSugestoes.hidden = true;
      }
    }

    gatilho.addEventListener('click', function () {
      abrir(!cabecalho.classList.contains('busca-aberta'));
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && cabecalho.classList.contains('busca-aberta')) {
        abrir(false);
        gatilho.focus();
      }
    });

    /* Tocar fora fecha. O clique no próprio cabeçalho é ignorado para o
       gatilho não abrir e fechar na mesma tocada. */
    document.addEventListener('click', function (evento) {
      if (!cabecalho.classList.contains('busca-aberta')) return;
      if (!evento.target.closest('[data-cabecalho]')) abrir(false);
    });

    /* Ao passar para desktop a busca volta a ser fixa na barra: descarta o
       estado aberto para não sobrar a linha extra ao voltar para o celular. */
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) abrir(false);
    });
  }

  /* ------------------------------------------------------------ Reveal -- */

  /* O CSS deixa .reveal visível. Quem esconde é aqui, e só o que já nasce
     abaixo da primeira dobra: o que está na tela no primeiro pixel nunca pode
     sumir esperando este script, que é deferido e roda depois de todo o HTML.
     Era isso que segurava o Speed Index — a home ficava com a área visível em
     branco até o parser terminar 23 seções.

     Sem IntersectionObserver não escondemos nada: a página fica estática, que
     é degradação melhor que conteúdo invisível para sempre. */
  function iniciarReveal() {
    var alvos = $$('.reveal');
    if (!alvos.length || !('IntersectionObserver' in window)) return;

    /* Todas as medidas primeiro, todas as classes depois: intercalar leitura
       de geometria com escrita de classe força um reflow por elemento, e numa
       home cheia isso são mais de cem reflows seguidos. */
    var dobra = window.innerHeight || document.documentElement.clientHeight;
    var forasDaDobra = alvos.filter(function (alvo) {
      return alvo.getBoundingClientRect().top >= dobra;
    });
    if (!forasDaDobra.length) return;

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('esta-visivel');
            observador.unobserve(entrada.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.05 }
    );

    forasDaDobra.forEach(function (alvo) {
      alvo.classList.add('reveal--animar');
      observador.observe(alvo);
    });
  }

  /* ------------------------------------------------------------ Facets -- */

  /* "1.299,00" digitado por gente vira "1299.00", que é o que a Shopify espera
     no parâmetro de preço. A regra do separador decimal é a última vírgula ou
     ponto do texto; "1.299" é a exceção conhecida — três dígitos depois de um
     ponto sozinho é separador de milhar, não centavo. */
  function precoParaNumero(texto) {
    var limpo = String(texto || '').replace(/[^\d.,]/g, '');
    if (!limpo) return '';

    var corte = Math.max(limpo.lastIndexOf(','), limpo.lastIndexOf('.'));
    if (corte === -1) return limpo;

    var inteiro = limpo.slice(0, corte).replace(/[.,]/g, '');
    var resto = limpo.slice(corte + 1).replace(/[.,]/g, '');

    if (limpo.charAt(corte) === '.' && limpo.indexOf(',') === -1 && resto.length === 3) {
      return inteiro + resto;
    }

    return resto ? inteiro + '.' + resto : inteiro;
  }

  function normalizarPrecos(form) {
    $$('[data-preco-filtro]', form).forEach(function (campo) {
      campo.value = precoParaNumero(campo.value);
    });
  }

  function iniciarFiltros() {
    $$('[data-filtros-form]').forEach(function (form) {
      if (jaIniciado(form, 'filtrosIniciado')) return;

      form.addEventListener('change', function () {
        normalizarPrecos(form);
        form.submit();
      });

      /* form.submit() por JS não dispara este evento, por isso a normalização
         acima é feita à mão. Aqui cobrimos o botão "Filtrar", que dispara. */
      form.addEventListener('submit', function () {
        normalizarPrecos(form);
      });
    });

    $$('[data-ordenar]').forEach(function (select) {
      if (jaIniciado(select, 'ordenarIniciado')) return;

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ------------------------------------------------------------- Start -- */

  function iniciar() {
    iniciarDrawers();
    iniciarAccordion();
    iniciarAbas();
    iniciarSliders();
    iniciarHero();
    iniciarAnuncios();
    iniciarQuantidade();
    iniciarHeader();
    iniciarReveal();
    iniciarFiltros();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* Reinicia comportamentos quando o editor de temas recarrega uma seção. */
  document.addEventListener('shopify:section:load', function () {
    iniciarSliders();
    iniciarHero();
    iniciarAnuncios();
    iniciarAbas();
    iniciarReveal();
    iniciarHeader();
  });
})();
